module.exports = __webpack_public_path__ + "static/media/logo.2eed222c.png";